/*
 * @Author: etong
 * @Date: 2021-01-27 13:51:41
 * @LastEditTime: 2021-07-28 15:48:13
 * @LastEditors: your name
 * @Description:
 * @FilePath: \oak\src\api\log.js
 * Think first, Program later
 */
import request from '@/utils/request'

// 日志GET /api/Supplier/GetHistory/{id}
export function logList(query) {
  return request({
    url: 'Supplier/GetHistory',
    method: 'get',
    params: query
  })
}
// 表头+详情日志
export function GetDocumentHistory(query) {
  return request({
    url: 'Supplier/GetDocumentHistory',
    method: 'get',
    params: query
  })
}

// 获取 多层级嵌套操作日志 (活动提报 操作日志)
export function GetMainHistory(data) {
  return request({
    url: 'Supplier/GetMainHistory',
    method: 'post',
    data: data
  })
}

// 低代码平台日志
export function BusinessLog(query) {
  return request({
    url: 'ibs/BusinessLog',
    method: 'get',
    params: query
  })
}

// 刷新表字段配置缓存
export function InitTableCache() {
  return request({
    url: 'ibs/BusinessLog/InitTableCache',
    method: 'get'
  })
}

// 库存台账一览 ==> 中台/旺店通库存对比日志
export function DiffDealLog(data) {
  return request({
    url: 'WdtStockQuery/QueryDiffDealWithLog',
    method: 'get',
    params: data
  })
}

